<div class="flex w-full">
  <div class="w-full">
    <div class="pt-3 sm:pt-4 md:pt-6">
      <div class="flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6 border-b border-[#c9ced3] pb-[1px] px-2 sm:px-3 md:px-0">
        <div>
          <app-header [title]="'Category Management'"
            [subTitle]="'Organize and curate your AI generation models with custom categories.'"></app-header>
        </div>
        <div class="flex items-center gap-[27px]">
          <div class="wallet-box d-flex align-items-center px-2 py-1 rounded"
            [ngbTooltip]="(credits ?? 0) === 0 ? 'Contact admin' : null"
            triggers="mouseenter:mouseleave" placement="bottom" container="body">
            <span class="wallet-icon me-1">💰</span>
            <span class="wallet-amount">Credits: {{ credits ?? 0 }} </span>
          </div>
          <div class="flex items-center">
            <app-common-button (clickEvent)="openCategoryForm()" buttonClass="smallbutton"
              [buttonLabel]="'Add Category'"></app-common-button>
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-visible px-2 sm:px-3 md:px-6 pb-4 pt-[15px]">
      <div class="custom-table-list !mt-0">
        <div class="custom-table-list-headings hidden md:flex">
          <div class="custom-col-width-50 th-item">
            Category Name
          </div>
          <div class="custom-col-width-50 th-item">
            Keyword to Categorize
          </div>
        </div>

        <div infiniteScroll [scrollWindow]="true" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500"
          (scrolled)="loadMoreCategories()" class="flex flex-col">
          <div *ngIf="loading && categories.length === 0" class="custom-table-list-row-main">
            <div class="custom-col-width-100 text-danger d-flex justify-content-center">
              <app-common-icon [loadingIcon]="loading"></app-common-icon>
            </div>
          </div>

          <div *ngFor="let category of categories; trackBy: trackByCategoryId"
            class="custom-table-list-row-main flex flex-col md:flex-row">
            <div class="custom-col-width-50 td-item mb-2 md:mb-0">
              <span class="block truncate font-semibold md:font-normal">{{ category.name }}</span>
            </div>

            <div class="custom-col-width-50 td-item mb-2 md:mb-0">
              <div class="flex flex-wrap gap-1">
                <span *ngFor="let keyword of category.keywords"
                  class="inline-flex items-center gap-1 rounded-md border border-[#de7141] bg-[#fde8dd] px-2 py-1 text-[12px] font-light text-[#de7141]">
                  {{ keyword }}
                </span>
              </div>
            </div>
          </div>
          <div *ngIf="!loading && categories.length === 0"
            class="flex justify-center w-full overflow-hidden whitespace-nowrap text-ellipsis">
            <span class="text-red-600 text-[16px] font-medium">No Data Found</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Right-side Drawer Overlay -->
<div class="overlay" [class.show]="isFormOpen"></div>

<div class="off-canvas width-750" [class.show]="isFormOpen">
  <div class="offCanvas__container">
    <div class="offCanvas__contentWrapper">

      <!-- Header -->
      <div class="offCanvas__header">
        <h2 class="offCanvas__title">{{ formTitle }}</h2>
        <button type="button" (click)="closeCategoryForm()" class="offCanvas__crossIcon">
          <img src="/assets/images/user-management/Cross.svg" alt="Close drawer" />
        </button>
      </div>

      <!-- Content -->
      <div class="offcanvas__content">
        <form class="offcanvas__networkDetails">

          <!-- Category Name and Keywords Row -->
          <div class="grid grid-cols-2 gap-4 mb-[20px] items-start px-3">
            <div>
              <app-input-filed label="Category Name" placeholder="Enter category name" [control]="categoryNameControl"
                [starIcon]="'*'" (focusEvent)="categoryNameControl.markAsTouched()" (change)="cdr.markForCheck()">
              </app-input-filed>
              <p class="text-xs text-red-500 font-normal mt-1 h-[16px]"
                *ngIf="categoryNameControl.touched && !categoryNameControl.value?.trim()">
                Please enter a category name
              </p>
            </div>

            <!-- Keywords to Categorize -->
            <div *ngIf="metadataForms.length > 0" class="flex flex-col gap-1">
              <label class="text-[#5f6d7e] text-[14px] font-light leading-[24px]">
                Keywords to Categorize <span class="text-red-500">*</span>
              </label>
              <div class="keywords-input-box">
                <div class="flex flex-wrap gap-1 items-center">
                  <span *ngFor="let keyword of metadataForms[0].keywordsList || []; let i = index"
                    class="inline-flex items-center gap-1 rounded-md border border-[#de7141] bg-[#fde8dd] px-1.5 py-[2px] text-[13px] font-light text-[#de7141]">
                    {{ keyword }}
                    <button type="button" (click)="removeMetadataKeyword(i, 0)"
                      class="bg-transparent border-none p-0 text-[#5f6d7e] hover:text-[#272d37] cursor-pointer">
                      <fa-icon [icon]="faTimes" class="text-[10px]"></fa-icon>
                    </button>
                  </span>
                </div>
                <input type="text" [formControl]="metadataForms[0].keywordsControl"
                  (keydown.enter)="addMetadataKeyword($event, 0)"
                  (blur)="metadataForms[0].keywordsControl.markAsTouched()" placeholder="Enter keyword"
                  class="flex-1 min-w-[120px] border-none outline-none bg-transparent text-[14px] font-light text-[#1b295c] py-[2px] placeholder:text-[#5f6d7e]">
              </div>
              <p class="text-xs text-red-500 font-normal mt-1 h-[16px]"
                *ngIf="metadataForms[0].keywordsControl.touched && metadataForms[0].keywordsList.length === 0">
                Please add at least one keyword
              </p>
            </div>
          </div>

          <!-- Metadata Input Section -->
          <div class="mb-[20px]">
            <div class="border border-[#e2e8f0] rounded-lg p-3 bg-[#f8fafc] overflow-y-auto">
              <!-- Metadata Forms - Show Label and Type in one row -->
              <div *ngFor="let form of metadataForms; let formIndex = index" class="py-3 relative last:pb-0">

                <!-- Action Buttons - Top Right -->
                <div class="absolute top-0 right-0 flex gap-1.5 z-10">
                  <button type="button" *ngIf="formIndex === metadataForms.length - 1" (click)="addNewMetadataForm()"
                    title="Add new form"
                    class="px-2 py-1 bg-orange-600 text-white rounded transition-colors duration-200 flex items-center justify-center">
                    <fa-icon [icon]="faPlus" class="text-xs"></fa-icon>
                  </button>
                  <button type="button" *ngIf="formIndex > 0" (click)="removeMetadataForm(formIndex)"
                    class="px-2 py-1 bg-orange-600 text-white rounded transition-colors duration-200 flex items-center justify-center">
                    <fa-icon [icon]="faTrash" class="text-xs"></fa-icon>
                  </button>
                </div>

                <!-- Form Fields -->
                <div class="flex gap-3 items-start">
                  <!-- Metadata Label -->
                  <div class="flex-1 min-w-[200px]">
                    <app-input-filed label="Metadata" placeholder="Enter Metadata" [control]="form.labelControl"
                      [starIcon]="'*'" (focusEvent)="form.labelControl.markAsTouched()" (change)="cdr.markForCheck()">
                    </app-input-filed>
                    <p class="text-xs text-red-500 font-normal mt-1 h-[16px]"
                      *ngIf="form.labelControl.touched && !form.labelControl.value?.trim()">
                      Please enter a metadata
                    </p>
                  </div>

                  <!-- Metadata Type -->
                  <div class="flex-1 min-w-[150px]">
                    <app-dropdown label="Metadata Type" placeholder="Select type" [options]="fieldTypeOptions"
                      [control]="form.fieldTypeControl" [starIcon]="'*'">
                    </app-dropdown>
                    <p class="text-xs text-red-500 font-normal mt-1 h-[16px]"
                      *ngIf="form.fieldTypeControl.touched && !form.fieldTypeControl.value">
                      Please select a metadata type
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- Dynamic Prompts -->
          <div class="mb-[20px] px-3">
            <app-text-area label="Dynamic Prompts" placeholder="Enter dynamic prompts" [control]="descriptionControl"
              [className]="'mb-[8px] text-[14px] font-light leading-[24px] text-[#5f6d7e]'"
              (focusEvent)="onDescriptionFocus()" (blurEvent)="onDescriptionBlur()">
            </app-text-area>
          </div>

        </form>
      </div>

    </div>

    <!-- Footer -->
    <div class="offCanvas__footer">
      <app-common-button (clickEvent)="closeCategoryForm()" buttonClass="smallbutton" buttonLabel="Cancel">
      </app-common-button>
      <app-common-button (clickEvent)="saveCategory()" buttonClass="smallFilledButton" disableButtonClass="disabledBtn"
        buttonLabel="Save" [disabled]="isSaveButtonDisabled" [loadingIcon]="isSavingCategory">
      </app-common-button>
    </div>

    <app-error-toaster *ngIf="errorMsg" [title]="errorMsg" (closeToaster)="closeToaster()"></app-error-toaster>

  </div>
</div>